export default __webpack_public_path__ + "static/Austin-LightItalic-88d4b69651a75d6d1c9fb2a13b4b6591.woff2";